import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { UserInformation } from '../../../models/api';

const namespaced = true;

export default {
  namespaced,
  state() {
    return {
      user: null as UserInformation,
    };
  },
  actions,
  getters,
  mutations,
};
